import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@ids-components';
import {
  ASSESSMENT_RESULTS,
  ASSESSMENT_RESULT_LABELS,
  COMPLIANCE_STANDARDS,
  COMPLIANCE_STANDARD_OPTIONS,
  FOUNDATIONAL_REQUIREMENT_LABELS,
} from '@ids-constants';
import { AssessmentService } from '@ids-services';
import { MODULES } from '../../../modules';
import { ORGANIZATION_ID_PARAM_ROUTE, PROJECT_ID_PARAM_ROUTE, PER_PAGE, PER_PAGE_OPTIONS } from '@microsec/constants';
import { PROJECT_MANAGEMENT_CONSTANTS } from '@ids-constants';
import { ASSESSMENT_TOOL_CONSTANTS } from '../../../project-management/evaluate/assessment-tool/assessment-tool.config';

import { finalize } from 'rxjs';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CardComponent } from '@microsec/components';
import { CommonModule } from '@angular/common';
import { DataViewModule } from 'primeng/dataview';
import { MultiSelectModule } from 'primeng/multiselect';
import { MomentPipe } from '@ids-pipes';

@Component({
  selector: 'app-device-compliance',
  templateUrl: './device-compliance.component.html',
  styleUrls: ['./device-compliance.component.scss'],
  imports: [CommonModule, FormsModule, SelectButtonModule, MultiSelectModule, DataViewModule, SelectModule, CardComponent, MomentPipe],
})
export class DeviceComplianceComponent extends BaseComponent implements OnInit {
  isLoading = false;

  _device = false;

  get device() {
    return this._device;
  }

  @Input() set device(value: any) {
    this._device = value;
    this.setComplianceResults();
    this.setAssessments();
  }

  detailsViewOptions = [
    { value: 'compliance', label: 'Device Compliance' },
    { value: 'assessment', label: 'Assessment History' },
  ];

  selectedDetailsView = 'compliance';

  complianceResults: any[] = [];

  complianceStandard = COMPLIANCE_STANDARDS.IEC_62443;

  assessments: any[] = [];

  assessmentTypes: any[] = [];

  selectedAssessmentTypeIds: any[] = [];

  ASSESSMENT_RESULTS = ASSESSMENT_RESULTS;

  ASSESSMENT_RESULT_LABELS = ASSESSMENT_RESULT_LABELS;

  COMPLIANCE_STANDARD_OPTIONS = COMPLIANCE_STANDARD_OPTIONS;

  PER_PAGE = PER_PAGE;

  PER_PAGE_OPTIONS = PER_PAGE_OPTIONS;

  constructor(private assessmentSrv: AssessmentService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    await this.prepareConfigs();
    this.getAssessmentTypes();
  }

  setComplianceResults() {
    if (!!this.device?.compliance?.[COMPLIANCE_STANDARDS.IEC_62443]) {
      const complianceResults: any[] = Object.values(FOUNDATIONAL_REQUIREMENT_LABELS).map((label, i) => ({
        label: label,
        target: this.device.compliance[COMPLIANCE_STANDARDS.IEC_62443].security_level_target?.[i],
        capability: this.device.compliance[COMPLIANCE_STANDARDS.IEC_62443].security_level_capable?.[i],
        achieved: this.device.compliance[COMPLIANCE_STANDARDS.IEC_62443].security_level_achieved?.[i],
      }));
      this.complianceResults = complianceResults;
    } else {
      this.complianceResults = [];
    }
  }

  setAssessments() {
    const assessments = this.util.sortObjectArray(
      ((this.device?.assessments as any[]) || [])
        .filter((assessment) =>
          this.selectedAssessmentTypeIds?.length ? this.selectedAssessmentTypeIds?.includes(assessment.assessment_type_id) : true,
        )
        .map((assessment) => ({
          ...assessment,
          assessmentType: this.assessmentTypes?.find((assessmentType) => assessmentType.id === assessment.assessment_type_id) || null,
        })),
      'assessment_completed_date',
      false,
      true,
    );
    this.assessments = assessments;
  }

  getAssessmentTypes() {
    this.isLoading = true;
    this.assessmentSrv
      .getAssessmentTypes(this.breadcrumbConfig?.organizationId, this.breadcrumbConfig?.projectId)
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.setAssessments();
        }),
      )
      .subscribe({
        next: (res) => {
          this.assessmentTypes = res.assessment_types || [];
        },
        error: (error) => {
          this.showErrorMessage(error);
        },
      });
  }

  goToAssessmentPage(assessment: any) {
    this.assessmentSrv.selected = !!assessment ? assessment : null;
    this.changeRoute(
      `${MODULES.PROJECT_MANAGEMENT.ROUTE.replace(ORGANIZATION_ID_PARAM_ROUTE, this.breadcrumbConfig?.organizationId?.toString()).replace(
        PROJECT_ID_PARAM_ROUTE,
        this.breadcrumbConfig?.projectId?.toString(),
      )}/${PROJECT_MANAGEMENT_CONSTANTS.ASSESSMENT_TOOL.ROUTE}/${ASSESSMENT_TOOL_CONSTANTS.ASSESSMENTS.ROUTE}`,
    );
  }
}
